import { useMemo } from 'react';
import { LoginData } from '../../model/LoginData';
import { CanjeResponse } from '../../rest/CanjeResponse';
import { post } from '../../rest/api';
import { URL_API_CANJE_CANCEL } from '../../constants/urls';

/**Cancelación de canje */
export function useCanjeCancel(loginData: LoginData | null) {
  const cancelResponse = useMemo(
    () => (resp: CanjeResponse) => {
      if (resp && loginData?.updateToken) loginData.updateToken(resp.token, resp.expirationDate);
    },
    [loginData]
  );

  const cancelCanje = useMemo(
    () => () => {
      post(URL_API_CANJE_CANCEL, {}, cancelResponse, undefined, loginData);
    },
    [loginData, cancelResponse]
  );

  return cancelCanje;
}
